import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';

export const FAIcon = (props: FontAwesomeIconProps) => {
  return <FontAwesomeIcon style={{ color: 'currentcolor' }} {...props} />;
};
